import { ReactNode } from "react";

import styled from "styled-components";
import _css from "@styled-system/css";
import {
  color,
  ColorProps,
  layout,
  LayoutProps,
  typography,
  TypographyProps,
  space,
  SpaceProps,
} from "styled-system";

export type TitleProps = LayoutProps &
  ColorProps &
  TypographyProps &
  SpaceProps & {
    id?: string;
    css?: string;
    color?: string;
    children: ReactNode;
    textAlign?: "left" | "center" | "right";
  };

const StyledTitle = styled.h1<Partial<TitleProps>>`
  box-sizing: border-box;
  overflow: hidden;
  letter-spacing: 0.13px;
  ${_css({
    fontSize: "h1",
    lineHeight: "normal",
    fontWeight: "semiBold",
    fontFamily: "normal",
  })}
  ${color}
    ${layout}
    ${typography}
    ${space}
    ${(props) => props.css}
`;

export default function Title({
  children,
  color = "black",
  fontSize,
  textAlign = "center",
  ...props
}: TitleProps) {
  return (
    <StyledTitle
      color={color}
      fontSize={fontSize}
      textAlign={textAlign}
      {...props}
    >
      {children}
    </StyledTitle>
  );
}
